// ProgressBar.js

import PropTypes from "prop-types";

const ProgressBar = ({ currentStep, totalSteps }) => {
  // const percentage = (currentStep / totalSteps) * 100;

  // Step labels array
  const stepLabels = [
    "Subscription Plans",
    "User Information",
    "Billing Address",
    "Payment Information",
    "Review and Submit",
  ];

  return (
    <div className="progress-container">
      {/* <div className='progress-bar' style={{ width: `${percentage}%` }} /> */}
      <div className="progress-steps">
        {Array.from({ length: totalSteps }, (_, index) => (
          <ul key={index}>
            <li
              className={`step ${
                index < currentStep
                  ? "completed"
                  : index === currentStep - 1
                  ? "current"
                  : ""
              }`}
            >
              {index + 1}
            </li>
            <p>{stepLabels[index] || `Step ${index + 1}`}</p>
          </ul>
        ))}
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default ProgressBar;
